// istanbul ignore file
import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'

const ZKpiDefinition = z.object({
  kpi_definition_id: z.string(),
  kpi_name: z.string(),
  kpi_description: z.string(),
  is_custom_kpi: z.boolean(),
  is_asset_level: z.optional(z.boolean()),
  asset_type: z.optional(z.string()),
  totalizer_type: z.optional(z.string())
})
const ZTiqKpiDefinitionDTO = z.object({
  totalCount: z.number(),
  content: z.array(ZKpiDefinition)
})
const ZKpiResponse = z.object({
  error: z.boolean(),
  http_status: z.number(),
  data: ZTiqKpiDefinitionDTO.nullable()
})

export async function getDeviceLevelKpiList (
  assetType: string,
  onSuccess: (kpiList: any, httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any
): Promise<void> {
  const url = `/kpirest/api/v1/udp/tiq/kpi/allKpiDetails?assetType=${assetType}`
  interceptedAxios
    .get(url, { timeout: 15000 })
    .then((response: any) => {
      const parseResponse = ZKpiResponse.safeParse(response.data)
      if (parseResponse.success) {
        if (
          parseResponse.data.data !== null && parseResponse.data.data !== undefined
        ) {
          onSuccess(parseResponse.data.data, response.status)
        } else {
          onFailure(parseResponse.data.error, response.status)
        }
      } else {
        onFailure(parseResponse.error.message, response.status)
      }
    })
    .catch((error: any) => {
      onFailure(error.message, error.response.status)
    })
}
